import { NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ContextService } from '@apply4u/services/context-service';
import { Navigation } from '@apply4u/shared/constant/navigation/navigation';

@Component({
  selector: 'dropdown-items',
  templateUrl: './dropdown-items.component.html',
  styleUrls: ['./dropdown-items.component.css'],
  standalone: true,
  imports: [NgIf, RouterLink, RouterLinkActive]
})
export class DropdownItemsComponent implements OnInit {
  Navigations = Navigation;
  SearchState: boolean = false;
  CVsState: boolean = false;
  JobsState: boolean = false;
  ContextService: ContextService;

  constructor(public contextService: ContextService) {
    if (this.contextService.IsBrowser) {
      this.ContextService = this.contextService;
    }
  }

  SearchToggle(event: MouseEvent) {
    this.SearchState = !this.SearchState
    event.stopPropagation();
  }

  CVsToggle(event: MouseEvent) {
    this.CVsState = !this.CVsState
    event.stopPropagation();
  }

  JobsToggle(event: MouseEvent) {
    this.JobsState = !this.JobsState
    event.stopPropagation();
  }

  ngOnInit() {
  }
}
